import { Injectable } from '@angular/core';
import { Violation } from '../models/violation';
import { StateValidator } from '../interfaces/state-validator';
import { ValidationMode } from '../enum/validation-mode.enum';
import { ConstraintTypeEnum } from '../enum/constraint-type.enum';
import { Shipment } from '../models/shipment';
import { shipmentConstraints } from '../constants/shipment-constraints';

@Injectable({ providedIn: 'root' })
export class ShipmentAddressesValidator implements StateValidator {

    supports(constraintType: ConstraintTypeEnum): boolean {
        return constraintType === ConstraintTypeEnum.SHIPMENT;
    }

    validate(state: any, constraintType: ConstraintTypeEnum, mode: ValidationMode): Violation[] {
        const shipment: Shipment = state;

        if (constraintType !== ConstraintTypeEnum.SHIPMENT) {
            throw new Error('Invalid constraint type');
        }

        return shipmentConstraints
            .filter(c => c.mode === mode)
            .filter(c => c.validator(shipment))
            .map(c => ({
                id: c.id,
                path: c.path,
                message: c.message(shipment)
            }));
    }
}
